import {
  ESS,
  MY_PROFILE,
  MY_LEAVE,
  MY_LOANS,
  MY_PAYSLIPS,
  MY_TAX_CERT,
  MY_PF,
  MY_GF,
  MY_COMP_OFF,
  ATTENDANCE_REQUEST,
  TEAM_ATTENDANCE,
} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {guard} from './route-guard'

// The "ESS" (Employee Self Service) top menu groups every "My …" self-service
// page under /ess. Module folders live in @modules/ess/*; each page's ACL feature
// url was updated to match (grants survive — they're keyed by feature_id).
export const EssRoutes: IAppRoutes = {
  link: ESS,
  childrens: [
    {
      // Self-service: the logged-in employee's own employee record — personal, contact, emergency,
      // education, experience and documents. Official/HR-owned fields render read-only.
      link: MY_PROFILE,
      element: guard(() => import('@modules/ess/my-profile'), [MY_PROFILE]),
    },
    {
      // Self-service: the logged-in employee's own leave applications.
      link: MY_LEAVE,
      element: guard(() => import('@modules/ess/my-leave'), [MY_LEAVE]),
    },
    {
      // Self-service: the logged-in employee's own loans & advances.
      link: MY_LOANS,
      element: guard(() => import('@modules/ess/my-loans'), [MY_LOANS]),
    },
    {
      // Self-service: the logged-in employee's own payslips.
      link: MY_PAYSLIPS,
      element: guard(() => import('@modules/ess/my-payslips'), [MY_PAYSLIPS]),
    },
    {
      // Self-service: the logged-in employee's own tax certificates (per fiscal year).
      link: MY_TAX_CERT,
      element: guard(() => import('@modules/ess/my-tax-certificate'), [MY_TAX_CERT]),
    },
    {
      // Self-service: the logged-in employee's own comp-off claims + credit ledger.
      // (Spending a credit happens on My Leave, against the comp-off-flagged leave type.)
      link: MY_COMP_OFF,
      element: guard(() => import('@modules/ess/my-comp-off'), [MY_COMP_OFF]),
    },
    {
      // Self-service: the logged-in employee's own provident-fund contributions & balance.
      link: MY_PF,
      element: guard(() => import('@modules/ess/pf-balance'), [MY_PF]),
    },
    {
      // Self-service: the logged-in employee's own accrued gratuity balance.
      link: MY_GF,
      element: guard(() => import('@modules/ess/gf-balance'), [MY_GF]),
    },
    {
      // Self-service: the logged-in employee's own attendance requests / regularization.
      link: ATTENDANCE_REQUEST,
      element: guard(() => import('@modules/ess/attendance-request'), [ATTENDANCE_REQUEST]),
    },
    {
      // Self-service: the caller's own team attendance (line manager + direct reports).
      link: TEAM_ATTENDANCE,
      element: guard(() => import('@modules/ess/team-attendance'), [TEAM_ATTENDANCE]),
    },
  ],
}
